import { AbstractReportPmsApiService } from '../abstract-report.service';
import { FrontDeskArrivalReport } from '../../../models/reports/front-desk/arrival-report.model';

/**
 * @class FrontDeskArrivalReportPmsApiService
 * @extends {AbstractReportPmsApiService<FrontDeskArrivalReport>}
 */
export class FrontDeskArrivalReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/front-desk/arrival';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {FrontDeskArrivalReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new FrontDeskArrivalReport(attributes);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/front-desk/arrival-report.service.js